import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {AccountModel} from "../models/account.model";
import {AccountsActions, AccountsAPiActions, AccountsChannelActions} from "./accounts.actions";
import {Update} from "@ngrx/entity";
import {Service} from "../../../deliveries/models/service.model";

export interface AccountState extends EntityState<AccountModel> {
  cursor: string;
  isLoading: boolean;
  initialized: boolean;
}

const adapter: EntityAdapter<AccountModel> = createEntityAdapter<AccountModel>();

const initialState: AccountState = adapter.getInitialState({
  cursor: null,
  isLoading: false,
  initialized: false
});

const reducer = createReducer(
  initialState,

  on(AccountsChannelActions.notificationReceived, (state, {notification}) => {

    if (state.entities[notification.id]?.updatedAt < notification.updatedAt) {
      // const changes: Update<Service> = {
      //   id: notification.id,
      //   changes: {...notification}
      // }
      // return adapter.updateOne(changes, state);
      return adapter.setOne(notification, state);
    } else {
      return state;
    }

  }),

  on(AccountsAPiActions.getAccount, (state) => ({...state, isLoading: true})),

  on(AccountsAPiActions.getAccountSuccess, (state, {account}) =>
    adapter.setOne(account, {...state, isLoading: false, initialized: true})
  ),

  on(AccountsAPiActions.getAccountFailure, (state) => ({...state, isLoading: false})),

  on(AccountsAPiActions.getAccounts, (state) => ({...state, isLoading: true})),

  on(AccountsAPiActions.getAccountsSuccess, (state, {accounts, cursor}) =>
    adapter.setMany(accounts, {...state, cursor: cursor, isLoading: false, initialized: true})
  ),

  on(AccountsAPiActions.getAccountsFailure, (state) => ({...state, isLoading: false})),

  on(AccountsAPiActions.updateAccountSuccess, (state, {account}) => {
      return adapter.setOne(account, state)
    }
  ),

  on(AccountsAPiActions.deleteAccountSuccess, (state, {account}) =>
    adapter.removeOne(account.id, state)
  ),

  on(AccountsActions.clearStore, () => ({...initialState}))
);

export const accountsFeature = createFeature({
  name: 'Accounts',
  reducer,
  extraSelectors: ({selectEntities, selectCursor, selectAccountsState, selectIsLoading, selectInitialized}) => ({
    ...adapter.getSelectors(selectAccountsState),
    selectAccounts: () => createSelector(
      selectEntities,
      (entities) => Object.values(entities),
    ),
    selectAccountsByIds: (ids: string[]) => createSelector(
      selectEntities,
      (entities) => {
        const accounts = [];
        ids?.forEach(id => {
          if (!!entities[id]) {
            accounts.push(entities[id]);
          }
        })
        return accounts;
      }
    ),
    selectAccount: (id: string) => createSelector(
      selectEntities,
      (entities) => entities[id],
    ),
    selectCursor: () => createSelector(
      selectCursor,
      (cursor) => cursor
    ),
    selectIsLoading: () => createSelector(
      selectIsLoading,
      (isLoading) => isLoading
    ),
    selectInitialized: () => createSelector(
      selectInitialized,
      (initialized) => initialized
    )
  }),
})
